import { render, staticRenderFns } from "./UserSettingsBusiness.vue?vue&type=template&id=3c8e6ae8&"
import script from "./UserSettingsBusiness.vue?vue&type=script&lang=js&"
export * from "./UserSettingsBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports